import React from 'react'

import { Loading, Page } from '@fielded/shared-ui'

import { usePageLoading } from '../../../../../van-shared/hooks/pageLoading'
import { hasFeature } from '../../../../../van-shared/utils/features'
import { shipmentTitle } from '../../../common/utils'
import { getNavigationItem } from '../../../../../common/utils/navigationInfo'

import PSMDeliveryCard from '../shared/PSMDeliveryCard/PSMDeliveryCard'
import { UploadOutboundsShipmentLink } from '../shared/UploadOutboundsShipmentLink'
import PSMStockTransfersEmptyState from './PSMStockTransfersEmptyState'

export const VIEW_TYPES = {
  PACKED: 'packed',
  COMPLETE: 'completed'
}

const getSubNavigationItems = (showCompleted) => {
  // We are getting the pathname from history since the url can differ depending if the user is viewing this page from Stock Transfer or Outbound Shipments
  // TODO: Replace with correct url after these are merged
  return [
    {
      title: 'Packed',
      path: '/shipments/stock-transfers',
      active: !showCompleted
    },
    {
      title: 'Completed',
      path: '/shipments/stock-transfers/completed',
      active: showCompleted
    }
  ]
}

function PSMStockTransfers (
  {
    config,
    shipments,
    history,
    showCompleted
  }) {
  const {isPageLoading} = usePageLoading()
  const showRealStockTransferStatus = hasFeature(config.features, 'stockTransfers:showRealStatus')

  const getShipmentStatus = (shipment) => {
    let shipmentStatus = 'packed'
    if (showRealStockTransferStatus || showCompleted) {
      shipmentStatus = shipment.status
      if (shipment.status === 'new') {
        shipmentStatus = 'scheduled'
      }
    }
    return shipmentStatus
  }

  return (
    <Page className='shipments'>
      <Page.ComposableHeader>
        <Page.ComposableHeader.Breadcrumb
          items={[getNavigationItem({item: 'shipments', config, includePath: false})]}
        />
        <Page.ComposableHeader.Content>
          <Page.ComposableHeader.Title title='Stock Transfer' />
          <Page.ComposableHeader.SubNavigation
            label=''
            items={getSubNavigationItems(showCompleted)}
          />
        </Page.ComposableHeader.Content>
      </Page.ComposableHeader>

      {isPageLoading ? (
        <Loading />
      ) : (
        <Page.Panel narrow alignLeft>
          {shipments.length ? (
            <section>
              <section className='vs-u-row vs-u-justify-end'>
                <UploadOutboundsShipmentLink
                  url='/shipments/stock-transfers/new/download'
                />
              </section>

              {shipments.map(shipment => {
                const headerTitle = shipmentTitle(shipment, config)
                return (
                  <PSMDeliveryCard
                    key={shipment.snapshotId}
                    headerTitle={headerTitle}
                    history={history}
                    shipment={shipment}
                    statusText={getShipmentStatus(shipment)}
                    target={`/shipments/stock-transfers/${shipment.snapshotId}`}
                  />
                )
              })}
            </section>
          ) : (
            <PSMStockTransfersEmptyState />
          )}
        </Page.Panel>
      )}
    </Page>
  )
}

export default PSMStockTransfers
